import useCanSeeBillingPageForSubscriptionTypes from '@apps/www/src/www/hooks/useCanSeeBillingPageForSubscriptionTypes';

export default function useCanSeeBillingPage() {
	const types = useCanSeeBillingPageForSubscriptionTypes();

	return types.length > 0;
}
